import { OktaAuth } from '@okta/okta-auth-js'

export const oktaAuth: OktaAuth = (window as any).__CONTAINER_OKTA_AUTH__ ?? new OktaAuth({
    issuer: process.env.REACT_APP_OKTA_ISSUER ?? 'https://www.dummyissuer.com',
    redirectUri: `${window.location.origin}/implicit/callback`,
    pkce: true,
})

// Helper to get env from container or process.env
export const getEnv = (key: string): string | undefined => {
    return (window as any).__CONTAINER_ENV__?.[key] ?? process.env[key]
}
